var map = {
	"./ai10.png": 2632,
	"./ai11.png": 6497,
	"./ai12.png": 5386,
	"./ai13.png": 9491,
	"./ai8.png": 7411,
	"./ai9.png": 9834,
	"./alquraanlive.png": 4224,
	"./blockthebeat.png": 5285,
	"./default.png": 2190,
	"./dig1.png": 2472,
	"./paint0.png": 3253,
	"./paint1.png": 7804,
	"./paint2.png": 4215,
	"./paint3.png": 5902,
	"./paint4.png": 6913,
	"./paint5.png": 2696,
	"./pho0.png": 5892,
	"./pho1.png": 9133,
	"./pho2.png": 7366,
	"./pho3.png": 1167,
	"./pho4.png": 3136,
	"./pho5.png": 7337,
	"./pho6.png": 9154,
	"./pho7.png": 699,
	"./tex0.png": 596,
	"./tex1.png": 6749,
	"./tex2.png": 6070,
	"./tex3.png": 4159,
	"./tex4.png": 5504,
	"./tex5.png": 329,
	"./tex6.png": 5186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6654;